import { render, staticRenderFns } from "./honorandcommendation.vue?vue&type=template&id=02fb8670&scoped=true&"
import script from "./honorandcommendation.vue?vue&type=script&lang=js&"
export * from "./honorandcommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fb8670",
  null
  
)

export default component.exports